import { getFreeBusyItemBarStyling, getFreeBusyStripClass, FreeBusyType } from 'owa-freebusy-style';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import * as React from 'react';

const styles = require('./AgendaFreeBusyBar.scss');
let classNames = require('classnames');

export const AgendaFreeBusyBar = function AgendaFreeBusyBar(props: {
    color: ColorScheme;
    freeBusyType: FreeBusyType;
}) {
    const { color, freeBusyType } = props;
    const freeBusyStyling = getFreeBusyItemBarStyling(freeBusyType, color);
    const freeBusyClass = getFreeBusyStripClass(freeBusyType);
    return <div className={classNames(styles.bar, freeBusyClass)} style={freeBusyStyling} />;
};
